import Table from 'components/Display/Table/Table'
import Page from 'components/Page/Page'
import useConsumers from 'logic/Consumers/useConsumers'
import useFormConsumerLogic from 'logic/Consumers/useFormConsumerLogic'
import React from 'react'
import tableActions from 'constants/tableActions'
import {
    useCreateConsumerMutation,
    useEditConsumerMutation,
    useDeleteConsumerMutation,
    useGetConsumersQuery,
    useGetConsumerQuery,
} from 'store/Store'

const Consumers = () => {
    return (
        <Page>
            <Table
                itemName="consumer"
                paginationType="external"
                allowDelete
                allowEdit
                allowCreate
                allowExpanded
                useEditMutation={useEditConsumerMutation}
                useGetQuery={useGetConsumersQuery}
                useGetByIdQuery={useGetConsumerQuery}
                useCreateMutation={useCreateConsumerMutation}
                useDeleteMutation={useDeleteConsumerMutation}
                useModal={useConsumers}
                useFormLogic={useFormConsumerLogic}
                tableActions={tableActions.consumersTableActions}
            />
        </Page>
    )
}

export default Consumers
